import { createTransfer } from "../crud/auth.crud";
import { Constants } from "./Constants";
import Swal from "sweetalert2";

const ERROR_MESSAGES = {
  usuario_nao_admin: {
    icon: "error",
    title: "Acesso Restrito",
  },
  empresa_sem_acesso: {
    icon: "warning",
    title: "Sua empresa não possui acesso ao PUMP",
    text: "Este recurso não está habilitado no seu plano atual.",
    showSalesLink: true,
  },
  default: {
    icon: "error",
    title: "Ops!",
    text:
      "Ocorreu um erro ao tentar acessar o PUMP. Por favor, tente novamente.",
  },
};

const showErrorAlert = (errorType, message) => {
  const config = ERROR_MESSAGES[errorType] || ERROR_MESSAGES.default;

  const alertConfig = {
    icon: config.icon,
    title: config.title,
    text: config.text || message,
    confirmButtonText: "Entendi",
    confirmButtonColor: "#284EEA",
  };

  if (config.showSalesLink) {
    alertConfig.html = `
      <p>${message}</p>
      <p style="margin-top: 16px;">
        <strong>Quer conhecer o PUMP?</strong><br/>
        Acesse nossa página de vendas para saber mais.
      </p>
    `;
    alertConfig.confirmButtonText = "Conhecer o PUMP";
    alertConfig.showCancelButton = true;
    alertConfig.cancelButtonText = "Fechar";
    delete alertConfig.text;

    Swal.fire(alertConfig).then((result) => {
      if (!result.isConfirmed) return;
      window.open("https://evento.lincohnagner.com.br/pv-shelby/", "_blank");
    });
    return;
  }

  Swal.fire(alertConfig);
};

export const openPump = async () => {
  const target = window.open("about:blank", "_blank") || window;

  try {
    const res = await createTransfer("pump");
    target.location.href = `${Constants.pumpFrontendUrl}/auth/sso?token=${res.data.transfer_token}`;
  } catch (err) {
    target.location.href = "about:blank";
    if (target !== window) target.close();

    const errorType = err.response?.data?.error;
    const errorMessage = err.response?.data?.message;

    showErrorAlert(errorType, errorMessage);
  }
};
